export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Get base URL for file uploads (remove /api suffix)
export const getFileURL = (path) => {
  const baseURL = API_URL.replace(/\/api$/, '');
  return `${baseURL}${path}`;
};

// Get auth token from localStorage
const getAuthToken = () => localStorage.getItem('authToken');

// API call helper with auth token
const apiCall = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'API request failed');
  }

  return response.json();
};

export const registrationAPI = {
  // Get all registrations (admin only)
  getAll: async () => {
    return apiCall('/registrations');
  },

  // Create new registration (public)
  create: async (data) => {
    // If data contains formData (FormData object), use it directly
    if (data.formData instanceof FormData) {
      const response = await fetch(`${API_URL}/registrations`, {
        method: 'POST',
        body: data.formData, // Don't set Content-Type, let browser set it with boundary
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Registration failed');
      }

      return response.json();
    }

    // Otherwise use the old JSON method
    return apiCall('/registrations', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Update registration status (admin only)
  updateStatus: async (id, status) => {
    return apiCall(`/registrations/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },

  // Export to Excel (admin only)
  exportExcel: async () => {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}/registrations/export/excel`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Export failed');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `registrations-${Date.now()}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },
};

export const authAPI = {
  // Login
  login: async (username, password) => {
    return apiCall('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  },

  // Verify token
  verify: async () => {
    return apiCall('/auth/verify');
  },
};
